import { Injectable } from '@angular/core';
import { Directionality } from '@angular/cdk/bidi';
import { Location, CurrencyPipe, DecimalPipe } from '@angular/common';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { Platform } from '@angular/cdk/platform';

import { DomSanitizer } from '@angular/platform-browser';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Router, NavigationEnd, NavigationExtras } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';

import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { BlockUI, NgBlockUI } from 'src/ngx-blockui/decorators/block-ui.decorator';

import { environment } from '../environments/environment';

import { MessageDialogComponent } from './dialogs/message-dialog/message-dialog.component';
import { ImageDialogComponent } from './dialogs/image-dialog/image-dialog.component';
import { AnimationDialogComponent } from './dialogs/animation-dialog/animation-dialog.component';
import { MessageSnackbarComponent } from './dialogs/message-snackbar/message-snackbar.component';

import mixpanel from 'mixpanel-browser';

import { appStrings_heIL } from './_core/static/translations_he-IL';
import { appStrings_enUS } from './_core/static/translations_en-US';
import { appStrings_enAU } from './_core/static/translations_en-AU';

import * as _ from 'lodash';
import dayjs from 'dayjs';
import { formatIncompletePhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

declare var gtag;

@Injectable({
	providedIn: 'root'
})
export class AppService {
	isProduction = environment.production;
	appConfig: any = environment.appConfig;
	isInApp = false;
	isAndroid: boolean;
	isIOS: boolean;


	private previousUrl: string;
	private currentUrl: string;

	$storage: any = {};
	$routeStorage: any = {};
	device: any = {};
	cacheContact: any = {};
	cachedPaymentInfo: any = null;
	wasRegPrompt = false;
	account: any = {
		favorites: [],
		history: [],
		sitePrefs: {
			order: [],
			book: [],
			pay: []
		}
	};

	cacheParams: any;
	urlParams: any = {};
	user = null;
	lUser: any;
	contact: any;
	version = '';
	needReload = false;

	initStorage() {

	}

	images: any = {
		profile_bg: 'profile_bg.svg',
		meal: 'no_image_square.png',
		meal_alt: 'default_meal.webp',
		default_cat_image: 'default-category.png',
		edit: 'edit.svg',
		his_delivery: 'his_delivery.svg',
		his_pay: 'his_pay.svg',
		his_ta: 'his_ta.svg',
		stock_en: 'sold-out-eng.svg',
		stock_il: 'sold-out-heb.svg',
	}
	stockImg;

	icons: any = ['bars', 'receipt', 'signin', 'signup', 'info_square', 'history', 'history_alt', 'refresh', 'check_alt', 'info_circle', 'paper_plane', 'call', 'credit_card', 'filter', 'like', 'like_active', 'map_pin', 'navigate', 'open', 'search', 'home', 'calendar_day',
		'money_check_alt', 'box_full', 'user_circle', 'trash', 'view', 'chart_pie_alt', 'hand_holding_usd',
		'cc', 'cc_amex', 'cc_diners', 'cc_discover', 'cc_jcb', 'cc_mastercard', 'cc_visa', 'check', 'minus',
		'accessibility', 'access-light', 'access-font', 'access-dark', 'access-monochrome', 'close', 'reload', 'download', 'split_payment',
		'pay-full', 'pay-partial', 'pay-items', 'globe', 'arrow_next', 'chevron_next', 'pen', 'list_check', 'users', 'plus', 'minus', 'user_outline', 'user_full', 'circle_chevron_down', 'heart', 'logo', 'signout', 'shield_check', 'shield_keyhole',
		'shopping-cart', 'caret_left', 'plus_circle', 'minus_circle', 'badge_percent',
		'edit', 'users-medical', 'users-viewfinder', 'user-check', 'package',
		'file_invoice_dollar',
		'lcard', 'mobile', 'loyalty', 'loyalty_benefit', 'loyalty_logo', 'loyalty_reg', 'utensils', 'crown', 'bell_concierge', 'dollar', 'chevron_next_light',
		'clipboard_list',
		'check-alt',
		'xmark',
		'arrows-rotate',
		'message-bot-duotone',
		'language',
		'tabot-ai',
		'cart-arrow-down',
		'circle-plus-duotone',
		'edit_alt',
		'chat-arrow',
		'chat-new',
		'microphone',
		'chat-square',
		'text-size',
		'ai-search',
		'envelope', 'sms', 'invoice',
	];

	backIcon: string;
	nextIcon: string;
	clientId: string;
	appStrings: any = {};
	region;
	regionArgs;
	locale;
	aiLocale: any = {};
	currency;
	selectedLocale;
	direction;
	showAppBanner: boolean;
	enableLogin: boolean;
	translations: any = {};

	regions = {
		"IL": {
			locale: "he-IL",
			name: "עברית",
			currency: '₪',
			decimals: 0,
			enableLogin: true,
			enableWallet: true,
			walletPMS: ["tabit","creditCard", "Cibus", "10bis"],
			enablePay: true,
			enablePaymentFees: false,
			promptOnNoTip: true,
			enableApp: false,
			enableByItems: true, //enable split payment by items
			requireLoginforAddItems: true,
			enableAnonymousLoginForOrderIn: true,
			allowNonDepositPayments: true,
			phoneCountry: 'il',
			preferredCountries: ['us', 'fr', 'gb', 'de', 'it', 'au'],
			enableDecimals: false,
			currencySignAtStart: false,
			hasTaxesAndFees: false,
			translations: ["he-IL", "en-US"],
			showDetailedFees: false,
			enableOrderIn: true,
			enableAutoLoyaltyLogin: true,
			alwaysShowLoyaltyButton: true,
			enableAccessibilityMenu: false,
			alcoholVerificationAge: 18,
			privacyDocURL: "https://legal.tabit.cloud/tabit-privacy/il",
			termsDocURL: "https://legal.tabit.cloud/tabit-terms/il",
			access: {
				"sitekey": "445d85504afc38b3bacf490fbcd4887e",
				"Menulang": "HE",
			}
		},
		"US": {
			locale: "en-US",
			currency: '$',
			decimals: 2,
			enableLogin: true,
			enableWallet: false,
			enablePay: true,
			enablePaymentFees: true,
			promptOnNoTip: true,
			enableApp: false,
			enableByItems: false,
			requireLoginforAddItems: false,
			enableAnonymousLoginForOrderIn: true,
			allowNonDepositPayments: true,
			phoneCountry: 'us',
			preferredCountries: ['mx', 'ca', 'gb', 'jp', 'ch', 'kr', 'de', 'br', 'fr', 'au'],
			enableDecimals: true,
			currencySignAtStart: true,
			hasTaxesAndFees: true,
			showDetailedFees: true,
			enableOrderIn: true,
			enableAutoLoyaltyLogin: false,
			enableAccessibilityMenu: false,
			alcoholVerificationAge: 21,
			privacyDocURL: "https://legal.tabit.cloud/tabit-privacy/us",
			termsDocURL: "https://legal.tabit.cloud/tabit-terms/us",
			access: {
				"sitekey": "79802115d3f22b8883dd080dc2ae8e72",
				"Menulang": "EN",
			}
		},
		"AU": {
			locale: "en-AU",
			currency: '$',
			decimals: 2,
			enableLogin: true,
			enableWallet: true,
			walletPMS: ["adyen"],
			enablePay: true,
			enablePaymentFees: false,
			promptOnNoTip: false,
			enableApp: true,
			enableByItems: false,
			requireLoginforAddItems: true,
			enableAnonymousLoginForOrderIn: true,
			allowNonDepositPayments: false,
			phoneCountry: 'au',
			preferredCountries: ['nz', 'us', 'in', 'sg', 'cn', 'jp', 'kr', 'id', 'my', 'ca', 'de', 'hk', 'fr', 'th', 'il'],
			enableDecimals: true,
			currencySignAtStart: true,
			hasTaxesAndFees: true,
			showDetailedFees: true,
			enableOrderIn: true,
			enableAutoLoyaltyLogin: true,
			enableAccessibilityMenu: false,
			alcoholVerificationAge: 18,
			privacyDocURL: "https://legal.tabit.cloud/tabit-privacy/au",
			termsDocURL: "https://legal.tabit.cloud/tabit-terms/au",
			access: {
				"sitekey": "ca28b098b387fa1583412b396ff4204c",
				"Menulang": "EN-AU",
			}
		}
	}
	locals: any[] = [
		{ id: "he-IL", transLang: "he-IL", name: "עברית", short: "HE", direction: 'rtl' },
		{ id: "en-US", transLang: "en-US", name: "English", short: "EN", direction: 'ltr' },
		{ id: "en-AU", transLang: "en-AU", name: "English", short: "EN", direction: 'ltr', fillFrom: "en-US"  },
	]
	aiLocals: any[] = [
		{ id: 'he-IL', transLang: 'he-IL', short: 'HE',  name: 'עברית', direction: 'rtl' },
		{ id: 'en-US', transLang: 'en-US', short: 'EN',  name: 'English', direction: 'ltr' },
		{ id: 'ar-IL', transLang: 'ar-IL', short: 'AR',  name: 'العربية', direction: 'rtl', fillFrom: "en-US" },
		{ id: 'ru-RU', transLang: 'ru-RU', short: 'RU',  name: 'Русский', direction: 'ltr', fillFrom: "en-US" },
		{ id: 'es-ES', transLang: 'en-US', short: 'ES',  name: 'Español', direction: 'ltr', fillFrom: "en-US" },
		{ id: 'fr-FR', transLang: 'en-US', short: 'FR',  name: 'Français', direction: 'ltr', fillFrom: "en-US" },
	];
	languages: { value, text }[] ;

	constructor(
		public directionality: Directionality,
		public dialog: MatDialog,
		public snackBar: MatSnackBar,
		public platformService: Platform,
		private http: HttpClient,
		private router: Router,
		private _location: Location,
		private sanitizer: DomSanitizer,
		private iconRegistry: MatIconRegistry,
		//private currencyPipe: DefaultCurrencyPipe,
	) {
		this.version = window["APPVERSION"];
		this.loadScripts(this.appConfig.includeScripts).then((loadCount) => {

		});
		let that = this;
		this.clientId = localStorage.getItem("TBCLIENTID");
		if (!this.clientId) {
			this.clientId = this.getObjectId();
			localStorage.setItem("TBCLIENTID", this.clientId);
		}
		this.appConfig.tabitLoyaltyAPI = this.appConfig.tabitAPI + "/services/loyalty";

		_.each(this.icons, (ico) => {
			this.iconRegistry.addSvgIcon(`${ico}`, sanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${ico}.svg`));
		});

		_.each(this.images, (val, key) => {
			that.images[key] = `/assets/images/${val}`;
		});
		// visual flags initialization
		this.isIOS = this.platformService.IOS || this.platformService.SAFARI;

		this.appStrings['he-IL'] = appStrings_heIL;
		this.appStrings['en-US'] = appStrings_enUS;
		this.appStrings['en-AU'] = appStrings_enAU;

		this.region = this.appConfig.region;
		this.regionArgs = this.regions[this.region];
		if (this.regionArgs.translations && this.regionArgs.translations.length) {
			this.languages = this.regionArgs.translations.map(value => {
				const _local = this.locals.find(l => l.id == value);
				return { value, text: _local.name }
			});
		}
		this.allowForeignNumbers();


		this.currency = this.regionArgs.currency;
		const selectedLocale = localStorage.getItem('locale');
		if (selectedLocale && this.regionArgs.translations && this.regionArgs.translations.includes(selectedLocale)) this.setLocale(selectedLocale);
		else this.setLocale(this.regionArgs.locale);

		// Style reCAPTCHA
		this.initRecaptcha();

		this.enableLogin = this.regionArgs.enableLogin == true;
		//this.showAppBanner = this.regionArgs.enableApp == true;

		this.urlParams = this.getURLParams();
		if (this.needReload) return;

		this.currentUrl = this.router.url;
		router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.previousUrl = this.currentUrl;
				this.currentUrl = event.url;
			}
		});

		let idevice: any = {};
		this.device = idevice;
		this.generateAccessibilityMenuScript();

		try {
			if (!this.appConfig.isDev) mixpanel.init(this.appConfig.mixpanelProjectToken, { persistence: 'localStorage' });
		} catch (err) {
			console.error('Mixpanel init error, not running');
		}

		if (window.innerWidth > 1000) {
			document.querySelector("html").classList.add("desktop");
		}

	}

	toggleTranslation() {
		const translations = this.regionArgs.translations;
		if (!translations) return
		let index = translations.indexOf(this.locale);
		let next = translations[index + 1];
		if (!next) next = translations[0];
		this.setLocale(next);
	}

	private translationSubject = new BehaviorSubject<string>(null);
	translation$ = this.translationSubject.asObservable();

	setLocale(locale) {
		if (locale != this.regionArgs.locale) localStorage.setItem('locale', locale);
		else localStorage.removeItem('locale');
		if (this.locale == locale) {
			this.aiLocale = this.selectedLocale;
			return;
		}
		this.locale = locale;
		if (this.selectedLocale && this.selectedLocale.bodyClass) {
			document.body.classList.remove(...this.selectedLocale.bodyClass.split(' ').filter(Boolean));
		}
		const oLocal = this.aiLocale = this.locals.find(l => l.id === locale) || this.locals[0];
		this.selectedLocale = oLocal;

		const newDirection = oLocal.direction;
		if (newDirection !== this.direction) {

			const htmlTag = document.documentElement;
			const cssLink = document.getElementById('bootstrap-css');
			if (newDirection === 'rtl') {
				// Switch to LTR
				htmlTag.setAttribute('dir', 'rtl');
				htmlTag.setAttribute('lang', 'he');
				cssLink.setAttribute('href', '/assets/bootstrap/bootstrap.rtl.min.css');
				this.backIcon = 'keyboard_arrow_right';
				this.nextIcon = 'keyboard_arrow_left';
			} else {
				htmlTag.setAttribute('dir', 'ltr');
				htmlTag.setAttribute('lang', 'en');
				cssLink.setAttribute('href', '/assets/bootstrap/bootstrap.min.css');
				this.backIcon = 'keyboard_arrow_left';
				this.nextIcon = 'keyboard_arrow_right';
			}
			htmlTag.classList.remove(this.direction);
			htmlTag.classList.add(newDirection);
			this.directionality.change.emit(newDirection);
		}

		this.direction = oLocal.direction;


		this.stockImg = locale == "he-IL" ? this.images.stock_il : this.images.stock_en;
		this.translations = this.appStrings[oLocal.transLang] || {};
		if (oLocal.fillFrom) {
			copyTranslationsRecursive(this.appStrings[oLocal.fillFrom], this.translations);
			delete oLocal.fillFrom;
		}
		this.updateAccessibilityMenuLanguage();
		function copyTranslationsRecursive(source, target) {
			_.forEach(source, (val, key) => {
				let reff = target[key];
				if (!reff) {
					target[key] = val;
				}
				else if (_.isObject(val)) {
					if (!_.isObject(reff)) target[key] = val;
					copyTranslationsRecursive(val, reff);
				}
			});
		}
		this.translationSubject.next(this.locale);
	}
	async setAiLocale(opt) {
		const localeId = opt.id;
		if (localeId === this.locale || (localeId && this.regionArgs.translations && this.regionArgs.translations.includes(localeId))) {
			this.setLocale(localeId);
			return;
		}

		this.aiLocale = opt;
		if (!opt.prepared) {
			await fetch(`/assets/translations/${opt.id}.json`, {
				method: 'get',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
			}).then(response => {
				return response.json();
			}).then(keys => {
				opt.keys = keys;
			}).catch(err => {

			}).finally(() => {
				opt.prepared = true;
			});
		}
		this.translationSubject.next(this.locale);
	}

	public getURLParams(_location?) {
		let urlParams: any = {};
		if (!_location) _location = location;
		_.each(_location.search.substr(1).split("&"), (ss) => {
			var _ss = ss.split("=");
			urlParams[_ss[0]] = _ss[1];
		});
		if (!urlParams.site) urlParams.virtualSite = true;

		// Loyalty Tokens

		['token', 'refreshToken', 'loyaltyToken', 'loyaltyRefreshToken'].forEach(tokenKey => {
			if (urlParams[tokenKey]) {
				localStorage.setItem(tokenKey, urlParams[tokenKey]);
				this.needReload = true;
			}
		});
		if (this.needReload) {
			const reloadParams = ['site', 'oid', 'price', 'flutter'].filter(field => urlParams[field]).map(field => `${field}=${urlParams[field]}`).join('&');
			const reloadURL = `${document.location.origin}/?${reloadParams}`;
			document.location.replace(reloadURL);
			return;
		}
		// End Loyalty Tokens


		this.cacheParams = { ...urlParams }

		//urlParams.site = "57c438f07d8fdb1e00b6f84d";
		//urlParams.oid = "5cbc3d1343e56e54edc27e3d";

		if (!urlParams.oid && !urlParams.site) {
			const oid = sessionStorage.getItem('oid');
			if (oid && oid != 'undefined') urlParams.oid = oid;
		} else if (urlParams.oid) {
			sessionStorage.setItem('oid', urlParams.oid);
		}

		if (!urlParams.site) {
			urlParams.site = sessionStorage.getItem('site') || null;
		} else {
			sessionStorage.setItem('site', urlParams.site);
		}

		if (urlParams.tableid) urlParams.tableId = urlParams.tableid;

		if (urlParams.flutter || sessionStorage.getItem('isInApp')) {
			this.isInApp = true;
			sessionStorage.setItem('isInApp', '1');
		}

		return urlParams;
	}

	public removeParamFromURL(sParams: string[]) {
		const urlObject = new URL(window.location.href);
		const params = new URLSearchParams(urlObject.search);
		const that = this;
		sParams.forEach(sParam => {
			params.delete(sParam);
			sessionStorage.removeItem(sParam);
			delete that.urlParams[sParam];
		});
		urlObject.search = params.toString();
		const newURL = urlObject.toString();
		window.history.pushState({}, '', newURL);
	}

	public backToSiteStart() {
		this.router.navigate(['/pay']);
	}

	public addItemsToOrder() {
		this.router.navigate(['/additems']);
		/*if (this.appConfig.envType == 'int' || this.region != 'US') {
			this.router.navigate(['/additems']);
		} else {
			let params = this.urlParams;
			if (!this.appConfig.tdURL) return this.alert({ content: "Missing tabit order end point" });
			let url = `${this.appConfig.tdURL}?site=${params.site}&oid=${params.oid}`;
			document.location.href = url;
		}*/
	}

	public createEatinOrder(hasBack: boolean = false, isAnonymous: boolean = false) {
		if (this.appConfig.envType == 'int' || this.regionArgs.enableOrderIn) {
			const navigationExtras: NavigationExtras = { state: { data: { hasBack: hasBack, isAnonymous: isAnonymous } } }
			this.router.navigate(['/orderin'], navigationExtras);
		} else {
			let params = this.urlParams;
			if (!this.appConfig.tdURL) return this.alert({ content: "Missing tabit order end point" });
			let url = `${this.appConfig.tdURL}?site=${params.site}&service=eatin`;
			if (params.table) url += `&table=${params.table}`;
			document.location.href = url;
		}
	}

	public goBack() {
		this._location.back();
	}

	public blockUI: NgBlockUI;

	public getErrorText(err, _default?) {
		let message;// = err.message;
		if (err.code) {
			message = this.getErrorCodeTrans(err.code);
		}
		if (!message) message = _default ? this.translate(_default) : err.message;
		return message;

	}
	public getErrorCodeTrans(code) {
		return this.translations._CODES[code];
	}

	public translate(path: string, args?, fallback?: string): string {
		if (!path) return "";
		const response = this.translateKey(this.translations, path, args);
		if (!response) return fallback || path;
		return response;
	}
	public translateKey(translations, path: string, args?) {
		const tokens = path.split('.');
		let translation: any = translations, missing: boolean;

		for (let i = 0; i < tokens.length; i++) {
			translation = translation[tokens[i]];
			if (!translation) return ;
			if (args && i == tokens.length - 1) {
				_.each(args, (val, key) => {
					translation = translation.replace(`{{${key}}}`, val);
				});
			}
		}
		return translation;
	}

	public objTranslate(prop: any, obj: string, _default: string): string {
		if (!obj || !prop) return this.translate(_default);
		let res = obj[prop];
		if (this.locale == this.regionArgs.locale) {
			res = _.get(obj, `translations.${this.locale}.${prop}`, res);
		}
		if (!res) return this.translate(_default);
		return res;
	}

	loadedScripts: any[] = [];
	public async loadScript(path: string): Promise<any> {
		if (this.loadedScripts.includes(path)) return;
		this.loadedScripts.push(path);
		return new Promise((resolve, reject) => {
			let script = document.createElement('script');
			script.onload = function (ev) {
				resolve(ev);
			}
			script.onerror = function (err) {
				console.error('LOAD SCRIPT ERRPR');
				reject(err);
			}
			script.src = path;
			document.head.appendChild(script);
		});
	}

	public getObjectId() {
		let timestamp = (new Date().getTime() / 1000 | 0).toString(16);
		return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
			return (Math.random() * 16 | 0).toString(16);
		}).toLowerCase();
	}

	sleep(ms: number): Promise<void> {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

	public serializeError(error) {
		try {
			let propertyNames = Object.getOwnPropertyNames(error);
			let descriptor, message;;
			for (let property, i = 0, len = propertyNames.length; i < len; ++i) {
				property = propertyNames[i];
				if (property == "message") {
					descriptor = Object.getOwnPropertyDescriptor(error, property);
					return descriptor.value;
				}
			}
		} catch (err) {
			return this.translate('error_general');
		}
	}

	getOrganization() {
		return _.get(this, 'urlParams.site', _.get(this.$storage, 'organization'));
	}

	public handleHttpError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {
			console.error(error); // log to console instead
			this.signOut();

			return of(result as T);
		};
	}

	public signOut(confirm?): void {
		if (confirm) {
			this.confirm({ content: 'MESSAGES.CONFIRM_SIGNOUT' }).then((res) => {
				this.signOut();
			}).catch(err => { });
			return;
		}
		localStorage.removeItem('token');
		localStorage.removeItem('refresh_token');
		this.user = null;
		this.router.navigate(['/sign-in', { from: 'user' }]);
	}

	public fixSpecialChars(str) {
		var regexSpecialChars = /[\uD83D\uFFFD\uFE0F\u203C\u3010\u3011\u300A\u166D\u200C\u202A\u202C\u2049\u20E3\u300B\u300C\u3030\u065F\u0099\u0F3A\u0F3B\uF610\uFFFC]/g;
		return str.replace(regexSpecialChars, "");
	}

	public imagesSrcCheck(src): Promise<boolean> {
		return new Promise(resolve => {
			let image = new Image();
			image.src = src;
			image.onload = () => resolve(true);
			image.onerror = () => resolve(false);
		})
	}

	storageToken_keys: string = "tabit_co_keys";
	restoreKEY(key) {
		let keys = JSON.parse(localStorage.getItem(this.storageToken_keys)) || {};
		return keys[key];
	};

	cacheKEY(key, val) {
		let keys = JSON.parse(localStorage.getItem(this.storageToken_keys)) || {};
		keys[key] = val;
		localStorage.setItem(this.storageToken_keys, JSON.stringify(keys));
	};

	public detectDevice(): string {
		// 768px width and above is considered desktop (iPad Portrait, which is 768px width should behave like Desktop)
		// Up to 767px width is considered Mobile
		// Landscape orientation is also considered desktop, as long as the width is less than 1024 (iPad landscape is 1024px width; iPhone in landscape mode is 896px)
		if (
			window.innerWidth < 768 ||
			(typeof window.orientation != 'undefined' && window.orientation != 0 && window.innerWidth < 1024)
		) {
			// console.log('=== AppService - Detect Device: Mobile');
			return 'mobile';
		} else {
			// console.log('=== AppService - Detect Device: Desktop');
			return 'desktop';
		}
	}
	public isDesktop() {
		return this.detectDevice() === 'desktop';
	}

	public confirm(args?) {
		return this.messageDialog(_.assignIn({ mode: 'confirm' }, args));
	}
	public alert(args?) {
		return this.messageDialog(_.assignIn({ mode: 'alert', title: 'error_title', content: null }, args));
	}
	public prompt(args?) {
		return this.messageDialog(_.assignIn({ mode: 'prompt', width: "400px", title: 'please_enter_value', content: null, label: 'please_enter_value' }, args));
	}
	public getSignature(args?) {
		return this.messageDialog(_.assignIn({ mode: 'signature', width: "300px", title: 'please_enter_signature', content: null, label: 'please_enter_signature' }, args));
	}

	public messageDialog(args?) {
		const base = _.assignIn({ mode: 'confirm', width: "300px", cancelText: 'Cancel', confirmText: 'OK', title: 'please_confirm', content: 'are_you_sure' }, args);
		return new Promise((resolve, reject) => {
			const dialogRef = this.dialog.open(MessageDialogComponent, {
				width: base.width,
				panelClass: 'rounded-dialog',
				direction: this.direction,
				data: base,
				maxWidth: '90vw',
				autoFocus: false
			});
			dialogRef.afterClosed()
				.subscribe(result => {
					if (result && result != "") {
						resolve(result);
					} else {
						reject(null);
					}
				});
		});
	}

	public imageDialog(url) {
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(ImageDialogComponent, {
				disableClose: false,
				panelClass: 'kiosk-image-dialog',
				direction: this.direction,
				data: { url: url },
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}

	public animDialog(args) {
		let that = this;
		let data:any = _.assignIn({ mode: 'alert', width: "300px", cancelText: 'Cancel', confirmText: 'OK', title: 'please_confirm', content: null }, args);
		//if (data.animation) data.path = `/assets/animations/${data.animation}.json`;

		if (data.darkTheme) {
			data.panelClass = ['animation-dialog','_dark'];
			data.backdropClass = 'dialog-backdrop-dark';
		}
		return new Promise((resolve, reject) => {
			let dialogRef = this.dialog.open(AnimationDialogComponent, {
				width: data.width,
				backdropClass: data.backdropClass,
				panelClass: data.panelClass || 'animation-dialog',
				data: data,
				autoFocus: false,
			});
			dialogRef.afterClosed().subscribe(result => {
				resolve(result);
			});
		});
	}

	public showContractDialog(mode = 'contract') {
		let url;
		switch (mode) {
			case "contract":
				url = this.regionArgs.termsDocURL;
				break;
			case "privacy":
				url = this.regionArgs.privacyDocURL;
				break;
		}
		if (url) window["open"](url, '_blank');
	}

	positionDialogTop(dialogRef) {
		try {
			if (dialogRef["_ref"]?.overlayRef?.overlayElement) {
				dialogRef['_ref'].overlayRef.overlayElement.parentElement.className += ' dialog-top-align-wrapper';
			}
		} catch (ex) { }
	}

	public toastrSimple(message, action?, duration = 3000) {
		if (!action) action = this.translate('okay')
		this.snackBar.open(message, action, {
			direction: this.direction,
			horizontalPosition: "center",
			verticalPosition: "top",
			duration: duration,
		});
	}

	public toastr(message, args?) {
		let _args = _.assignIn({ type: 'info', duration: 5000 }, args);
		message = this.translate(message);
		let options: MatSnackBarConfig = {
			direction: this.direction,
			panelClass: `_${_args.type}`,
			horizontalPosition: "center",
			verticalPosition: "top",
			duration: _args.duration,
			data: {
				message: message,

			}
		}
		this.snackBar.openFromComponent(MessageSnackbarComponent, options);
	}

	passByShare(args?) {
		return new Promise((resolve, reject) => {
			navigator.share({
				title: this.translate('OAT.share_order_api_title'),
				url: location.href,
			}).then(() => {
				console.log('Sharing success');
				resolve({});
			}).catch(() => {
				console.log('Sharing failiure');
				resolve(null);
			});
		});
	}
	copyShareLink() {
		navigator.clipboard.writeText(document.location.href);
	}

	startBlock(args: any = {}) {
		if (args.class) document.body.classList.add(...args.class.split(' ').filter(Boolean));
		if (args.text) args.text = this.translate(args.text);
		this.blockUI.start(args.text)
	}
	stopBlock(args: any = {}) {
		if (args.class) document.body.classList.remove(...args.class.split(' ').filter(Boolean));
		this.blockUI.stop();
	}

	formatPhoneNumber(phoneNumberString) {
		try {
			const phoneNumber = parsePhoneNumberFromString(phoneNumberString);
			if (phoneNumber.country == this.regionArgs.phoneCountry.toUpperCase()) {
				return phoneNumber.formatNational();
			} else {
				return phoneNumber.formatInternational();
			}
		} catch (e) { }
		try {
			return formatIncompletePhoneNumber(phoneNumberString);
		} catch (e) { }

		let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
		var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
		if (match) {
			return match[1] + '-' + match[2] + '-' + match[3]
		}
		return phoneNumberString;
	}

	allowForeignNumbers(allow?) {
		if (allow) {
			this.regionArgs.phonePreferredCountries = [this.regionArgs.phoneCountry].concat(this.regionArgs.preferredCountries);
			this.regionArgs.phoneOnlyCountries = [];
		} else {
			this.regionArgs.phonePreferredCountries = [];
			this.regionArgs.phoneOnlyCountries = [this.regionArgs.phoneCountry];
		}
	}

	isValidMobilePhone(phone) {
		let that = this;
		if (phone.indexOf("+972") === 0) {
			if (phone.charAt(4) == "5") return true;
			return isValidMobilePhone_throwError();
		}
		return true;

		function isValidMobilePhone_throwError() {
			that.alert({ content: "VALIDATIONS.CELL_FIELD_MSG"})
			return false;
		}
	}

	//-------------------------------------------------------->
	// time calculations
	//-------------------------------------------------------->

	public calcServerDateDiff(clientDate, serverDate) {
		if (serverDate) {
			window["SERVERDATEDIF"] = new Date(serverDate).valueOf() - clientDate.valueOf();
		}
	};

	public getRealDate() {
		var dif = window["SERVERDATEDIF"] || 0;
		var d = new Date().valueOf() + dif;
		return new Date(d);
	}

	public getRealDateMoment() {
		return dayjs(this.getRealDate());
	}


	//-------------------------------------------------------->
	// logs
	//-------------------------------------------------------->

	public sendAnalyticsEvent(_event, args) {
		try {
			gtag('event', _event, args);
		} catch (e) {
			console.error("gtag error", _event, args)
		}
	}

	public logError(err, actionType = 'errorInterceptor', message?) {
		if (!err || !err.url || err.url.indexOf(this.appConfig.tabitBridge) != -1) {
			return;
		}
		if (!message) {
			let errorURL = _.get(err, 'config.url', '').replace(this.appConfig.tabitAPI + '', '');
			message = `${actionType}: ${errorURL}`;
		}
		this.logTemplate(actionType, { error: JSON.stringify(err) }, message);
	}

	public logTemplate(actionType, data, message?, order?) {
		const timestamp = new Date();
		if (!order) order = _.get(this.$storage, 'order', {});

		if (!message) {
			message = actionType;
			switch (actionType) {
				case "orderFetched":
					message = "Order Fetched";
					break;
				case "errorInterceptor":
					message = "Error Interceptor";
					break;
				case "maxCreditPayment":
					message = "Max credit payment attempt";
					break;
				default:
					message = "Tabit Pay General Log";
					break;
			}
		}

		const loyaltyCustomer = this.lUser;
		const payload: any = {
			client: "tabitPay",
			message: `[TABITPAY] ${message}`,
			logVars: {
				source: this.appConfig.title,
				service: {
					name: this.appConfig.title
				},
				order: {
					id: order.order_id || _.get(this, 'urlParams.oid'),
					price: {
						amount: order.totals?.totalAmount,
						currency: this.currency == '₪' ? 'NIS' : 'USD',
					},
					screen_name: data?.step,
				},
				organization: {
					id: this.getOrganization(),
					name: _.get(this.$storage, 'site.name', null)
				},
				user: {
					id: _.get(loyaltyCustomer, 'CustomerId'),
					phone: _.get(loyaltyCustomer, 'Mobile', _.get(loyaltyCustomer, 'mobile')),
					name: _.get(loyaltyCustomer, 'FullName', _.get(loyaltyCustomer, 'fullName')),
					email: _.get(loyaltyCustomer, 'Email', _.get(loyaltyCustomer, 'email')),
				},
				version: this.version,
				device: {
					timestamp,
					id: this.clientId,
					useragent: navigator.userAgent,
				},
				payment: {
					amount: data?.totalPayment,
					action: data?.paymentMode,
					type: getLogPaymentType(data),
				},
				gratuity: {
					amount: data?.tipAmount,
				},
				payload: {
					tabitPay: {
						...{
							actionType,
							orderId: _.get(this, 'urlParams.oid'),
							serverUrl: this.appConfig.tabitAPI,
							userAgent: navigator.userAgent,
							route: document.location.href,
							version: this.version,
							deviceId: this.clientId,
							localDate: timestamp,
							timestamp,
							order: order._id,
							isTabOrder: order?.isTabOrder,
							isTabOrderPreAuth: order?.isTabOrderPreAuth != null
						}, ...data
					}
				}
			}
		}
		const logsAPI = this.appConfig.tabitBridge;
		if (logsAPI) {
			this.http.post(`${logsAPI}/logger`, payload)
				.subscribe(
					(results: any) => {
						console.debug(actionType, results);
					},
					(err) => {
						console.debug(`actionType error`, err);
					}
				);
		}

		function getLogPaymentType(data) {
			// First we check if it's wallet, then if Apple/Google Pay and last one - actual type
			const type = data?.walletPayment ? 'walletPayment' : _.get(data, 'nativePayment.type') || _.get(data, 'data.paymentType');
			return type;
		}
	}

	//-------------------------------------------------------------------------------->
	//recaptche
	//-------------------------------------------------------------------------------->

	public initRecaptcha() {
		if (environment.appConfig?.recaptchaSiteKey) {
			this.loadScript(`https://www.google.com/recaptcha/enterprise.js?render=${environment.appConfig.recaptchaSiteKey}`).then(() => {
				this.toggleReCaptchaPosition();
			}).catch(err => {

			});

			//const recaptchaScript = document.createElement('script');
			//recaptchaScript.async = true;
			//recaptchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${environment.appConfig.recaptchaSiteKey}`;
			//document.head.appendChild(recaptchaScript);

		}
	}

	public toggleReCaptchaPosition() {
		const styleId = 'pay-recaptcha-style';
		const styleScript = document.getElementById(styleId);

		// Add style
		if (!styleScript) {
			const script = document.createElement('style');
			script.id = styleId;

			script.innerHTML += `
            .grecaptcha-badge {pointer-events: none; z-index: 999; top: 0.1rem !important;}
            `;

			// US | AU
			if (this.locale !== 'he-IL') {
				script.innerHTML += `
                .grecaptcha-badge {direction: ltr; right: unset !important; width: 70px !important; overflow: hidden !important; transition: left 0.3s ease !important; left: 0px !important;}
                `;
			}

			document.head.appendChild(script);
			// Remove
		} else {
			const parentElement = styleScript.parentNode;
			// Remove the script element from the head
			parentElement.removeChild(styleScript);
		}
	}

	//-------------------------------------------------------------------------------->
	//accessibility
	//-------------------------------------------------------------------------------->

	generateAccessibilityMenuScript(): void {
		if (this.appConfig.isDev || !this.regionArgs.enableAccessibilityMenu) return;
		const siteKey = this.regionArgs.access.sitekey;
		if (!siteKey) return;

		window["interdeal"] = {
			get sitekey (){ return siteKey} ,
			get domains(){
				return {
					"js": "https://cdn.nagich.co.il/",
					"acc": "https://access.nagich.co.il/"
				}
			},
			"Position": this.direction == 'rtl' ? 'left' : 'right',
			"Menulang": this.regionArgs.access.Menulang,
			"draggable": true,
			"btnStyle": {
				"vPosition": [
					"50%",
					"50%"
				],
				"margin": [
					"0",
					"0"
				],
				"scale": [
					"0.8",
					"0.6"
				],
				"color": {
					"main": "#000000",
					"second": "#ffffff"
				},
				"icon": {
					"outline": true,
					"outlineColor": "#ffffff",
					"type":  11 ,
					"shape": "semicircle"
				}
			},

		};

		(function(doc, head, body){
			var coreCall             = doc.createElement('script');
			coreCall.src             = window["interdeal"].domains.js + 'core/5.2.0/accessibility.js';
			coreCall.defer           = true;
			coreCall.integrity       = 'sha512-fHF4rKIzByr1XeM6stpnVdiHrJUOZsKN2/Pm0jikdTQ9uZddgq15F92kUptMnyYmjIVNKeMIa67HRFnBNTOXsQ==';
			coreCall.crossOrigin     = 'anonymous';
			coreCall.setAttribute('data-cfasync', "true" );
			body? body.appendChild(coreCall) : head.appendChild(coreCall);
		})(document, document.head, document.body);


		/*		const siteKey = this.regionArgs.access.sitekey;
				if (!siteKey) return;
				const interdeal = {
					sitekey: siteKey ,
					domains: {
							"js": "https://cdn.nagich.co.il/",
							"acc": "https://access.nagich.co.il/"
					},
					Position: this.direction == 'rtl' ? 'left' : 'right',
					"Menulang": this.locale == 'he-IL' ? 'HE' : 'EN',
					"draggable": true,
					"btnStyle": {
						scale: ['0.5', '0.5'],
						vPosition: ['50%', '100px'],
						"margin": [ "0", "0" ],
						"color": { "main": "#000000","second": "#ffffff"},
						"icon": {
							"outline": false,
							"type":  11 ,
							"shape": "semicircle"
						}
					}
				}
				try {
					let coreCall= document.createElement('script');
					coreCall.src             = interdeal.domains.js + 'core/5.2.0/accessibility.js';
					coreCall.defer           = true;
					coreCall.integrity       = 'sha512-fHF4rKIzByr1XeM6stpnVdiHrJUOZsKN2/Pm0jikdTQ9uZddgq15F92kUptMnyYmjIVNKeMIa67HRFnBNTOXsQ==';
					coreCall.crossOrigin     = 'anonymous';
					coreCall.setAttribute('data-cfasync', "true" );
					document.body? document.body.appendChild(coreCall) : document.head.appendChild(coreCall);
				} catch (error) {
					console.error('Error in generating Interdeal script', error);
				}*/
	}

	updateAccessibilityMenuLanguage(): void {
		if (window['interdeal']?.setPosition) {
			window['interdeal'].setPosition(this.direction == 'rtl' ? 'right' : 'left');
			window['interdeal'].SetLocale(this.locale == 'he-IL' ? 'HE' : 'EN');
		}
	}

	getCleanUrlParams(queryParams) {
		const cleanParams = _.omit(queryParams, ['gl', '_gl', 'ga']);
		const params = new HttpParams({ fromObject: cleanParams });

		return params.toString();
	}

	getBaseLocation(queryParams?: any) {
		const path = `#${window.location.pathname}?${this.getCleanUrlParams(queryParams)}`;
		return path;
	}

	//-------------------------------------------------------------------------------->
	//full view
	//-------------------------------------------------------------------------------->

	public isScreenRecorderEnabled(site) {
		const screenRecorderSettings = site.screenRecorder;
		if (!screenRecorderSettings) return false;
		const allowedClients = screenRecorderSettings.allowedClients;
		if (!allowedClients) return false;
		return allowedClients.includes('tabitPay');
	}

	public initFullViewScript(): Promise<void> {
		return new Promise<void>((resolve, reject) => {

			if (!localStorage.getItem('FULLVIEWSESSIONID')) {
				localStorage.setItem('FULLVIEWSESSIONID', this.getObjectId());
			}

			const scriptId = 'fullview-script';
			const fvConfig = {
				src: 'https://install.fullview.io',
				'data-org': '3c88bb60-9b42-4858-ad6d-63aae589a129',
				id: scriptId,
			};
			const fvScript = document.createElement('script');
			Object.entries(fvConfig).forEach(([oKey, oVal]) => fvScript.setAttribute(oKey, oVal));

			fvScript.onload = () => {
				resolve();
			}

			document.body.appendChild(fvScript);
		});
	}

	initOrUpdateFullViewRecord(site, additionalData: any = {}) {
		const env = environment.env;
		const customData: any = {
			organization: this.getOrganization(),
			version: this.version,
			id: localStorage.getItem('FULLVIEWSESSIONID'), // Required - unique during the session
			host: document.location.host,
			name: _.get(site, 'config.name', site.name) + (additionalData?.customerName ? `-${additionalData?.customerName}` : ''), // Required - visible in Fullview dashboard
			disableReplaysForUser: false, // Optional - disable replays for specific users
			env,
			roles: ['tabit-pay'],
		}
		const userConfig = {
			...customData, //[key: string]: 'customData',  // Optional - use this to add multiple custom fields
			...additionalData
		}
		window['$fvIdentity'] = userConfig;
	}

	//-------------------------------------------------------------------------------->
	//mixpanel
	//-------------------------------------------------------------------------------->

	trackData(message, payload?) {
		const trackingData = {
			...{
				source: 'tabitPay',
				environment: this.appConfig.title,
				site_name: _.get(this.$storage, 'site.name', null),
				site_id: _.get(this, 'urlParams.site', _.get(this.$storage, 'organization')),
				version: this.version,
				userAgent: navigator.userAgent,
				platform: navigator.platform,
				route: document.location.href,
			},
			...payload
		}
		try {
			console.debug('MIXPANEL', message, trackingData);
			mixpanel.track(`TabitPay | ${message}`, trackingData);

		} catch (err) {
			console.log("mixpanel track error");
		}

	}

	//-------------------------------------------------------------------------------->
	//helpers
	//-------------------------------------------------------------------------------->

	parseCurrency(val, digitsInfo?) {
		if (["US", "AU"].includes(this.region)) return (new CurrencyPipe('en')).transform(val, null, this.currency, digitsInfo);
		else {
			const value = new DecimalPipe('he').transform(val, digitsInfo || '1.2-2');
			if (this.direction == 'rtl') return `${this.currency}${value}`;
			else return `${this.currency}${value}`;
		}
	}

	isAlphabetic(str) {
		try {
			return /[a-zA-Z\p{Script=Hebrew}]/u.test(str);
		} catch (e) {
			return true;
		}
	}

	loadScripts(urls) {
		return new Promise((resolve, reject) => {
			let loadedCount = 0;
			const total = urls.length;
			if (!urls || !urls.length) {
				resolve(loadedCount);
				return;
			}

			urls.forEach(url => {
				const script = document.createElement('script');
				script.src = url;
				script.async = true; // Non-blocking load

				// Function to run when a single script finishes
				script.onload = () => {
					loadedCount++;
					console.debug('Script loaded:', url);
					if (loadedCount === total) {
						resolve(loadedCount);
					}
				};

				// Handle load failures
				script.onerror = () => {
					console.error(`Error loading script: ${url}`);
					loadedCount++; // Increment anyway to allow others to continue
					if (loadedCount === total) resolve(loadedCount);
				};

				document.head.appendChild(script); // Append to trigger download
			});
		});
	}


}

import { HashLocationStrategy } from '@angular/common';
@Injectable()
export class ParameterHashLocationStrategy extends HashLocationStrategy {
	prepareExternalUrl(internal: string): string {
		//console.log('preparing external url', location.search, super.prepareExternalUrl(internal));
		return location.search + super.prepareExternalUrl(internal);
	}
}
